<div class="accessed-projects-container">
  <header class="dialog-header">
    <div class="dialog-title">
      <span class="title-icon"><fa-icon [icon]="faFolderOpen"></fa-icon></span>
      <div>
        <h2>Project activity</h2>
        <p>{{ data.session.UserLoginName }} <span></span> {{ data.session.Date | date:'MMM d, y' }}</p>
      </div>
    </div>
    <button type="button" class="icon-button" (click)="close()" title="Close" aria-label="Close dialog">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </header>

  <div class="dialog-summary">
    <div class="summary-item">
      <small>Active time</small>
      <strong>{{totalActiveHours}}</strong>
    </div>
    <div class="summary-divider"></div>
    <div class="summary-item">
      <small>Projects accessed</small>
      <strong>{{projects.length}}</strong>
    </div>
    <div class="summary-note">Expand or collapse a project to review its page-level activity.</div>
  </div>

  <main class="dialog-body">
    <div class="loading-state" *ngIf="isLoading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Loading project activity...
    </div>

    <div class="projects-list" *ngIf="!isLoading && projects.length > 0">
      <article class="project-item" *ngFor="let p of projects" [class.is-expanded]="isExpanded(p)">
        <button type="button" class="project-row" (click)="toggleBreakdown(p)"
          [attr.aria-expanded]="isExpanded(p)">
          <span class="expand-icon">
            <fa-icon [icon]="isExpanded(p) ? faChevronDown : faChevronRight"></fa-icon>
          </span>
          <span class="project-main">
            <strong>{{p.Name}}</strong>
            <small>Last opened {{p.LastAccessedOn | date:'MMM d, y, h:mm a'}}</small>
          </span>
          <span class="project-stat">
            <small>Visits</small>
            <strong>{{p.TotalAccessCount}}</strong>
          </span>
          <span class="project-stat">
            <small>Time spent</small>
            <strong>{{p.TotalTimeSpent}}</strong>
          </span>
        </button>

        <div class="breakdown-panel" *ngIf="isExpanded(p)">
          <table class="breakdown-table" *ngIf="hasBreakdown(p)">
            <thead>
              <tr>
                <th>Page or area</th>
                <th>Times opened</th>
                <th>Time spent</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let area of p.AreaBreakdown">
                <td data-label="Page or area">{{area.AccessArea}}</td>
                <td data-label="Times opened">{{area.AccessCount}}</td>
                <td data-label="Time spent"><span class="time-value">{{area.TotalTimeSpent}}</span></td>
              </tr>
            </tbody>
          </table>
          <div class="breakdown-empty" *ngIf="!hasBreakdown(p)">No page-level activity was recorded for this visit.</div>
        </div>
      </article>
    </div>

    <div class="empty-state" *ngIf="!isLoading && projects.length === 0">
      <fa-icon [icon]="faFolderOpen"></fa-icon>
      <strong>No project activity</strong>
      <span>No projects were accessed during this session.</span>
    </div>
  </main>

  <footer class="dialog-footer">
    <button type="button" class="close-action" (click)="close()">Close</button>
  </footer>
</div>
